import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BackTop from '@/components/base/BackTop';
import Hero from './components/Hero';
import LatestSection from './components/LatestSection';
import CpSection from './components/CpSection';
import CharSection from './components/CharSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '《师兄啊师兄》讲的是什么故事？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '这是一部热血仙侠动画，讲述身患绝症的李长寿意外重生到封神大战前的上古洪荒，成为度仙门炼气士，奉行稳健的生存哲学、低调求生的故事。',
      },
    },
    {
      '@type': 'Question',
      name: '本站的考据内容从哪来？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '所有人物关系、CP线、师门日常整理，均基于动画正片的逐集梳理与同好讨论归纳，供交流分享。',
      },
    },
    {
      '@type': 'Question',
      name: '追更指南会持续更新吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '新一季更新、人物关系图谱调整、名场面盘点都会持续补充，订阅邮箱后会有更新提醒。',
      },
    },
  ],
};

const webSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '师兄啊师兄考据站',
  url: 'https://languageworld.com.cn/',
  description: '师兄啊师兄人物关系、CP线、师门日常考据合集，磕糖考据党必备追更指南。',
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([webSchema, faqSchema]) }}
      />
      <Header />
      <main>
        <Hero />
        <LatestSection />
        <CpSection />
        <CharSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}